const config = {
  NAME_KEY: process.env.REACT_APP_NAME_KEY || "App",
  NAME_TITLE: process.env.REACT_APP_NAME_TITLE || "app",
  SERVER: process.env.NODE_ENV || "local",
  DEFAULT_LANGUAGE: process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
  REGISTORY_URL: process.env.REACT_APP_REGISTRY_URL,
};

export default config;
